import React, { useEffect, useState } from 'react';
import { Modal, List, Tag, Empty, Spin } from 'antd';
import { diagnosticService } from '../../services/diagnosticService';
import type { Procedure, VehicleSnapshot } from '../../services/diagnosticService';

const CATEGORY_COLOR: Record<string, string> = {
  engine_mech: 'red',
  electrical: 'blue',
  fuel: 'gold',
  inspection: 'green',
};

export interface ProcedurePickerProps {
  open: boolean;
  vehicle?: VehicleSnapshot;
  onPick: (p: Procedure) => void;
  onClose: () => void;
}

export const ProcedurePicker: React.FC<ProcedurePickerProps> = ({
  open,
  vehicle,
  onPick,
  onClose,
}) => {
  const [items, setItems] = useState<Procedure[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    diagnosticService
      .listProcedures(vehicle)
      .then(({ data }) => setItems(data.procedures))
      .finally(() => setLoading(false));
  }, [open, vehicle]);

  return (
    <Modal title="Pick a procedure" open={open} onCancel={onClose} footer={null} width={500}>
      {loading ? (
        <Spin />
      ) : items.length === 0 ? (
        <Empty />
      ) : (
        <List
          dataSource={items}
          renderItem={(p) => (
            <List.Item onClick={() => onPick(p)} style={{ cursor: 'pointer' }}>
              <List.Item.Meta
                title={
                  <>
                    <Tag color={CATEGORY_COLOR[p.category]}>{p.category}</Tag> {p.name}
                  </>
                }
                description={
                  p.spec_kind ? `Spec source: ${p.spec_kind}` : 'No external spec required'
                }
              />
            </List.Item>
          )}
        />
      )}
    </Modal>
  );
};
